import { Observable } from 'rxjs';
import { ProgramModel } from '../../models';

export abstract class BaseProgramService {
  public abstract getProgram(programNumber: string, maintainer?: string): Observable<ProgramModel>;
  public abstract getProgramRevision(uuid: string): Observable<any>;
  public abstract getSurveyRevision(surveyType: string, surveyId: string): Observable<any>;
}
